<template>
	<section class="main-content intro">
		<div class="row">
			<slot>
				<div class="columns column12 align-center">
					<h1>{{ title }}</h1>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
@media (max-width: 880px) {
	.intro {
		padding: 50px 0;
	}
}
</style>
